import {
  Box,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  IconButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import NewWalletModal from '../../../NewWalletModal';
import createWalletCardStyles from './CreateWalletCard.styles';
import { CreateWalletCardProps } from './types/CreateWalletCard.types';
import { currenciesToCreate, walletsThatCanBeCreated } from './utils';

const CreateWalletCard = ({
  addFunds,
  onConvert,
  walletsAleadyActive,
}: CreateWalletCardProps) => {
  const [openModal, setOpenModal] = useState(false);
  const { t } = useTranslation();

  if (
    walletsThatCanBeCreated(walletsAleadyActive).length === 0 &&
    openModal === false
  )
    return null;

  return (
    <Box id="add-wallet-button" className={createWalletCardStyles.card}>
      <Card>
        <CardActionArea onClick={() => setOpenModal(true)}>
          <CardContent className={createWalletCardStyles.cardContent}>
            <Box>
              <Typography variant="body2">Balance</Typography>

              <Typography variant="h6">00.00</Typography>
            </Box>

            <Box />
          </CardContent>

          <CardActions>
            <Box className={createWalletCardStyles.buttonToCreateWallet}>
              <IconButton>
                <AddIcon fontSize="small" />
              </IconButton>

              <Typography variant="body2">
                {t('createNewWallet', {
                  currenciesToCreate: currenciesToCreate({
                    walletsAleadyActive,
                    translations: t,
                  }),
                })}
              </Typography>
            </Box>
          </CardActions>
        </CardActionArea>

        <NewWalletModal
          onConvert={onConvert}
          addFunds={addFunds}
          isOpen={openModal}
          setOpen={setOpenModal}
        />
      </Card>
    </Box>
  );
};

export default CreateWalletCard;
